module.exports = __webpack_public_path__ + "static/media/under-line-dot.b9efe195.svg";